'use client';

import { useTranslations } from 'next-intl';

import { Button, Flex, Modal, Text } from '@mantine/core';

import useAiWaiting from '@hooks/useAiWaiting';

import { useAppContext } from '@context/AppContext';

import AiWaitingContent from './AiWaitingContent';

export default function AiWaitingModal({ data }) {
    const t = useTranslations();
    const [aiWaiting, setAiWaiting] = useAppContext('aiWaiting');
    const isErrorState = aiWaiting?.status === 'error';
    const {
        sentences,
        index,
        mounted,
        handleExited,
        onLike,
    } = useAiWaiting(aiWaiting.show, aiWaiting.module, data);

    const handleCloseError = () => {
        setAiWaiting({ show: false, module: '' });
    };

    const handleRetry = async () => {
        if (typeof aiWaiting?.retryAction !== 'function') {
            return;
        }

        await aiWaiting.retryAction();
    };

    if (!aiWaiting.show) {
        return null;
    }

    return (
        <Modal
            opened={aiWaiting.show}
            onClose={() => {}}
            size="xl"
            centered
            withCloseButton={false}
            zIndex={999999}
            overlayProps={{
                backgroundOpacity: 0.8,
                blur: 5,
            }}
        >
            {isErrorState ? (
                <Flex direction="column" justify="center" align="center" gap="md" p="xs">
                    <Text ta="center">ERREUR</Text>
                    <Text ta="center">
                        {aiWaiting?.errorMessage || 'Une erreur est survenue, veuillez réessayer.'}
                    </Text>
                    <Flex gap="sm" wrap="wrap" justify="center">
                        {typeof aiWaiting?.retryAction === 'function' && (
                            <Button onClick={handleRetry}>
                                {t('retry')}
                            </Button>
                        )}
                        <Button variant="light" onClick={handleCloseError}>
                            Fermer
                        </Button>
                    </Flex>
                </Flex>
            ) : (
                <AiWaitingContent
                    sentences={sentences}
                    index={index}
                    mounted={mounted}
                    handleExited={handleExited}
                    onLike={onLike}
                />
            )}
        </Modal>
    );
}
